import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, inject, Injectable, Output } from '@angular/core';
import { OnsetExamDataDto } from '../../dtos/onset-exam-data-dto';
import { OnsetExamResultDto } from '../../dtos/onset-exam-result-dto';
import { UrlService } from '../common/url.service';

@Injectable({
    providedIn: 'root',
})
export class ConnectorService {
    @Output() getOnsetExamDataCompleted: EventEmitter<OnsetExamDataDto> = new EventEmitter<OnsetExamDataDto>();
    @Output() postOnsetExamResultCompleted: EventEmitter<OnsetExamResultDto> = new EventEmitter<OnsetExamResultDto>();

    readonly #httpClient = inject(HttpClient);
    readonly #urlService = inject(UrlService);

    getOnsetExamData(token: string, env?: string) {
        let envParam = '';
        if (env && (env === 'staging' || env === 'develop')) {
            envParam = `/?env=${env}`;
        }

        this.#httpClient
            .get<OnsetExamDataDto>(this.#urlService.authServiceUrl() + 'connector' + '/' + 'onset' + '/' + token + envParam)
            .subscribe((res: OnsetExamDataDto) => { this.getOnsetExamDataCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                    this.getOnsetExamDataCompleted.emit(undefined);
                });
    }

    postOnsetExamResult(token: string, onsetExamResultDto: OnsetExamResultDto, env?: string) {
        let envParam = '';
        if (env && (env === 'staging' || env === 'develop')) {
            envParam = `/?env=${env}`;
        }
        this.#httpClient
            .post<OnsetExamResultDto>(this.#urlService.authServiceUrl() + 'connector' + '/' + 'onset' + '/' + token + '/' + 'results' + envParam, onsetExamResultDto)
            .subscribe((res: OnsetExamResultDto) => { this.postOnsetExamResultCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                });
    }

}

